// 加载全局样式样式

const Components = require.context('.', true, /\.vue$/)
Components.keys()
    .map(Components)
    .forEach((item) => {
        if (item.default.name && item.default.name !== 'Layouts')
            Vue.component(item.default.name, item.default)
    })

// 加载组件
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)

import * as frame from "@/dianwuyi/frame";
import * as wxWork from "@/dianwuyi/wx-work"
import * as utils from "@/dianwuyi/utils"

Vue.prototype.dayjs = dayjs
Vue.prototype.$frame = frame
Vue.prototype.$wxWork = wxWork
Vue.prototype.$utils = utils


// Vue.prototype.$wx = wx;